// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Utils
import { getNotificationType } from '../../../../../../common/notifications/notificationModelUtils';

// Selectors
import { enhancedNotificationSelector } from '../../../../../notifications/notificationsSelector';

// Components
import NotificationEntryShare from './entry/NotificationEntryShare';
import NotificationEntryUnshare from './entry/NotificationEntryUnshare';
import NotificationEntryComment from './entry/NotificationEntryComment';
import NotificationEntryBoardUpdate from './entry/NotificationEntryBoardUpdate';
import NotificationEntryBoardTasksUpdate from './entry/NotificationEntryBoardTasksUpdate';
import NotificationEntryShareReminder from './entry/NotificationEntryShareReminder';
import NotificationEntryBoardView from './entry/NotificationEntryBoardView';
import NotificationEntryMention from './entry/NotificationEntryMention';
import NotificationEntryGroupedBoardView from './entry/NotificationEntryGroupedBoardView';
import NotificationEntryAssignment from './entry/NotificationEntryAssignment';
import NotificationEntryTaskReminder from './entry/NotificationEntryTaskReminder';
import NotificationEntryReaction from './entry/NotificationEntryReaction';

// Constants
import { NOTIFICATION_TYPES } from '../../../../../../common/notifications/notificationConstants';

const NotificationListEntry = (props) => {
    const { notification } = props;

    const type = getNotificationType(notification);

    switch (type) {
        case NOTIFICATION_TYPES.SHARE:
            return <NotificationEntryShare {...props} />;
        case NOTIFICATION_TYPES.UNSHARE:
            return <NotificationEntryUnshare {...props} />;
        case NOTIFICATION_TYPES.SHARE_REMINDER:
            return <NotificationEntryShareReminder {...props} />;
        case NOTIFICATION_TYPES.BOARD_UPDATE:
            return <NotificationEntryBoardUpdate {...props} />;
        case NOTIFICATION_TYPES.BOARD_TASKS_UPDATE:
            return <NotificationEntryBoardTasksUpdate {...props} />;
        case NOTIFICATION_TYPES.BOARD_TASKS_REMINDER:
            return <NotificationEntryTaskReminder {...props} />;
        case NOTIFICATION_TYPES.COMMENT:
            return <NotificationEntryComment {...props} />;
        case NOTIFICATION_TYPES.BOARD_VIEW:
            return <NotificationEntryBoardView {...props} />;
        case NOTIFICATION_TYPES.MENTION:
            return <NotificationEntryMention {...props} />;
        case NOTIFICATION_TYPES.CLIENT_ONLY_GROUPED_BOARD_VIEW:
            return <NotificationEntryGroupedBoardView {...props} />;
        case NOTIFICATION_TYPES.ASSIGNMENT:
            return <NotificationEntryAssignment {...props} />;
        case NOTIFICATION_TYPES.REACTION:
            return <NotificationEntryReaction {...props} />;
        default:
            return null;
    }
};

NotificationListEntry.propTypes = {
    notification: PropTypes.object,
};

export default connect(enhancedNotificationSelector)(NotificationListEntry);
